// extracted by mini-css-extract-plugin
export default {"text":"style_text__kOTkZ"};